/* eslint-disable  */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-unresolved */
/* eslint-disable global-require */
/* eslint-disable  */
// @ts-nocheck
import * as React from 'react';
import {
  Grid,
  Box,
  Button,
  IconButton,
  InputLabel,
  TextField,
  Typography,
  Link,
  Divider,
  Paper,
  Tab,
  Tabs,
  List,
  ListItem,
  Popover,
  Autocomplete,
  Table,
  TableHead,
  TableBody,
  TableRow,
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CloseIcon from '@mui/icons-material/Close';
import MainLogo from '../../../components/MainLogo/MainLogo.components';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import InfoIcon from '@mui/icons-material/Info';
import { useRoomScene } from '../hooks/useRoomScene';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { useConfig } from '../../../config/useConfig';
import ChangePassword from '../ChangePassword/ChangePassword.screen';
import { useLogin } from '../hooks/useLogin';
import ChangeEmail from '../ChangeEmail/ChangeEmail.screen';
import DeleteAccountModal from '../DeleteAccount/DeleteAccountModal.screen';
import AdminControl from '../AdminControl/AdminControl.screen';
// Start Tab Code
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ div: 3 }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
// End Tab Code

const AccountDetails = ({ tabObj, closeDrawer }: { tabObj: object; closeDrawer: () => void }) => {
  // Start Tab Code
  const [value, setValue] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const { getPasswordOtp, getEmailOtp, deleteAccount } = useLogin();

  const handleModalClose = () => {
    setOpen(false);
  };

  const closeAllModal = () => {
    setOpen(false);
    closeDrawer();
  };

  const onDeleteAccount = () => {
    deleteAccount(handleModalClose, closeAllModal);
  };

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  // End Tab Code
  // Start Account Setting Code
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>, id) => {
    setRId(id);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const { getRoomScene } = useRoomScene();

  React.useEffect(() => {
    if (tabObj?.tab !== undefined || tabObj?.tab !== null) {
      setChng(null);
      setValue(tabObj?.tab);
    }
  }, [tabObj]);

  const opensecond = Boolean(anchorEl);
  const id = opensecond ? 'simple-popover' : undefined;
  // End Account Setting Code
  // Start Drawer Code
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const toggleDrawer = (newOpen: boolean) => () => {
    setOpenDrawer(newOpen);
  };
  const AccountBoxClose = () => {
    setOpenDrawer(false);
  };

  const { deleteRoomSceneById } = useRoomScene();
  const { roomScenes } = useAppSelector((state) => state.roomScene);
  const { userData } = useAppSelector((state) => state.user);
  const { baseURL } = useConfig();

  React.useEffect(() => {
    if (value == 1) {
      getRoomScene();
    }
  }, [value]);
  // End Drawer Code

  const handleDeleteRoomScene = (id) => {
    deleteRoomSceneById(id);
    setRId(null);
  };

  const [rId, setRId] = React.useState(null);
  const [chng, setChng] = React.useState(null);

  return (
    <>
      <Paper className="AccountDetailBox">
        <Paper className="TileGroutOptions">
          {chng === 'password' && (
            <ChangePassword email={userData?.user?.email} setChng={setChng} />
          )}
          {chng === 'email' && <ChangeEmail email={userData?.user?.email} setChng={setChng} />}
          {!chng && (
            <Box className="TabContainer">
              <Box className="TabHeader">
                <Tabs value={value} onChange={handleChangeTab} aria-label="basic tabs example">
                  <Tab label="General" {...a11yProps(0)} />
                  <Tab label="Saved Scenes" {...a11yProps(1)} />
                  {userData?.isAdmin && <Tab label="Analytics" {...a11yProps(2)} />}
                </Tabs>
              </Box>
              <Box className="TabContent AccountTabContent">
                <TabPanel value={value} index={0}>
                  <Box className="AccountDetails">
                    <Paper className="TileSelection">
                      <Typography variant="h6" className="AccountHeading">
                        <b>Account Details</b>
                      </Typography>
                      <Box className="CommonFormControl" sx={{ mt: 4 }}>
                        <InputLabel>Email</InputLabel>
                        <Box className="TextEditBox">
                          <TextField
                            defaultValue={userData?.user?.email}
                            InputProps={{
                              readOnly: true,
                            }}
                            variant="standard"
                            className="TextFieldReadOnly"
                          />
                          <Link
                            onClick={() => {
                              getEmailOtp(setChng);
                            }}
                          >
                            Change
                          </Link>
                        </Box>
                      </Box>
                      <Box className="CommonFormControl">
                        <InputLabel>
                          Password
                          <Typography variant="subtitle2" className="NoteBox">
                            (case sensitive)
                          </Typography>
                        </InputLabel>

                        <Box className="TextEditBox">
                          <TextField
                            defaultValue="12345678"
                            InputProps={{
                              readOnly: true,
                            }}
                            variant="standard"
                            className="TextFieldReadOnly"
                            type={'password'}
                          />
                          <Link
                            onClick={() => {
                              getPasswordOtp(setChng);
                            }}
                          >
                            Change
                          </Link>
                        </Box>
                      </Box>
                    </Paper>
                    <Box sx={{ mt: 4 }}>
                      <Divider></Divider>
                    </Box>
                    <Paper className="TilePattern">
                      <Button
                        className="DeleteLink NoHoverBg"
                        // endIcon={<DeleteOutlineIcon />}
                        onClick={() => setOpen(true)}
                      >
                        Delete Account
                      </Button>
                      <Typography variant="body2">
                        Permanently remove your account and all data associated with it
                      </Typography>
                    </Paper>
                  </Box>
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <Popover
                    id={'d'}
                    open={opensecond}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    className="OptionsPopover"
                  >
                    <Box className="OptionsPopoverBox">
                      <List>
                        <ListItem>
                          <Link
                            onClick={() => {
                              handleDeleteRoomScene(rId);
                              handleClose();
                            }}
                          >
                            Remove from saved scenes
                          </Link>
                        </ListItem>
                      </List>
                    </Box>
                  </Popover>
                  {roomScenes?.length > 0 ? (
                    []
                      .concat(roomScenes)
                      ?.reverse()
                      ?.map((item: any) => (
                        <Paper className="SavedScenes" key={item?._id}>
                          <Box className="GroutCanvas">
                            <Box
                              className="GroutContentBox"
                              style={{
                                backgroundImage: `url(${baseURL}/${encodeURIComponent(
                                  item?.roomImage,
                                )})`,
                              }}
                            ></Box>
                          </Box>
                          <Box className="SavedScenesHeader">
                            <Typography variant="h4">{item?.roomName}</Typography>
                            <IconButton
                              aria-describedby={item?._id}
                              onClick={(e) => handleClick(e, item?._id)}
                            >
                              <MoreHorizOutlinedIcon />
                            </IconButton>
                          </Box>
                          <Box className="SavedScenesGroutColor">
                            <Box>
                              <Typography variant="h6">Grout Colors</Typography>
                              <Grid container direction="row" columnSpacing={0}>
                                <Grid size={4} className="SavedScenesGroutCol">
                                  <Box
                                    className="GroutColour GroutColourSecond"
                                    onClick={toggleDrawer(true)}
                                  >
                                    <Box
                                      className="TileImageSecond"
                                      style={{
                                        backgroundColor: item?.tileOneBackgroundColor,
                                      }}
                                    ></Box>
                                    <Typography variant="h6" className="GroutName">
                                      <Box component="span">{item?.tileOneId}</Box>
                                      {item?.tileOneName}
                                    </Typography>
                                  </Box>
                                </Grid>
                                <Grid size={4} className="SavedScenesGroutCol">
                                  <Box
                                    className="GroutColour GroutColourSecond"
                                    onClick={toggleDrawer(true)}
                                  >
                                    <Box
                                      className="TileImageSecond"
                                      style={{
                                        backgroundColor: item?.tileTwoBackgroundColor,
                                      }}
                                    ></Box>
                                    <Typography variant="h6" className="GroutName">
                                      <Box component="span">{item?.tileTwoId}</Box>
                                      {item?.tileTwoName}
                                    </Typography>
                                  </Box>
                                </Grid>
                                <Grid size={4} className="SavedScenesGroutCol">
                                  <Box
                                    className="GroutColour GroutColourSecond"
                                    onClick={toggleDrawer(true)}
                                  >
                                    <Box
                                      className="TileImageSecond"
                                      style={{
                                        backgroundColor: item?.tileThreeBackgroundColor,
                                      }}
                                    ></Box>
                                    <Typography variant="h6" className="GroutName">
                                      <Box component="span">{item?.tileThreeId}</Box>
                                      {item?.tileThreeName}
                                    </Typography>
                                  </Box>
                                </Grid>
                              </Grid>
                            </Box>
                            <Box className="SavedScenesGroutJointWidth">
                              <Typography variant="h6">Grout Joint Width</Typography>
                              <Typography variant="body2">
                                {item?.tileTwoGroutWidth} {item?.tileThreeGroutWidth}
                              </Typography>
                            </Box>
                          </Box>
                        </Paper>
                      ))
                  ) : (
                    <Typography variant="h6">No Saved Scenes</Typography>
                  )}
                </TabPanel>
                <TabPanel value={value} index={2}>
                  <AdminControl />
                </TabPanel>
              </Box>
            </Box>
          )}
        </Paper>
      </Paper>
      <DeleteAccountModal
        open={open}
        handleClose={handleModalClose}
        onDeleteAccount={onDeleteAccount}
      />
    </>
  );
};
// Tile shape
const tileshape = [{ label: 'Last Week' }, { label: 'This Week' }];
export default AccountDetails;
